export default __webpack_public_path__ + "static/media/1 (1).d310266d.svg";